export default {
  lossOverflowReport: {
    search: {
      decreaseOverflowNo: '报损报溢单号',
      decreaseOverflowNoAdd: '保存后生成',
      decreaseOverflowNoPlaceholder: '请输入报损报溢单号',
      decreaseOverflowCreateDateStart: '制单日期起',
      decreaseOverflowCreateDateEnd: '制单日期至',
      decreaseOverflowCreateDate: '制单日期',
      storageNo: '仓库',
      decreaseOverflowDepartmentNo: '部门',
      decreaseOverflowCompanyName: '公司',
      decreaseOverflowType: '单据类型',
      product: '商品描述',
      batchNo: '业务批次号',
      decreaseOverflowBusinessPerson: '业务员',
      purchaseNo: '采购合同号/意向单号',
      decreaseOverflowStatus: '状态',
      partner: '供应商',
      decreaseOverflowQuantity: '损溢数量',
      decreaseOverflowPackage: '损溢件数',
      decreaseOverflowUnit: '单位',
      decreaseOverflowUnitPrice: '单价(不含税)',
      businessDecreaseOverflowAmount: '损溢金额',
      decreaseOverflowReason: '损溢原因',
      decreaseOverflowPart: '损溢环节',
      voucherNo: '财务凭证号',
      decreaseOverflowMark: '备注',
      accountingStatus: '入账状态',
      decreaseOverflowCreatePerson: '制单人',
      decreaseOverflowCreateDateStartPlaceholder: '请选择制单日期起',
      decreaseOverflowCreateDateEndPlaceholder: '请选择制单日期至',
      storageNoPlaceholder: '请选择仓库',
      decreaseOverflowDepartmentNoPlaceholder: '请选择部门',
      decreaseOverflowTypePlaceholder: '请选择单据类型',
      productPlaceholder: '请选择商品',
      batchNoPlaceholder: '请输入业务批次号',
      decreaseOverflowBusinessPersonPlaceholder: '请选择业务员',
      purchaseNoPlaceholder: '请选择采购合同号/意向单号',
      decreaseOverflowStatusPlaceholder: '请选择状态',
      partnerPlaceholder: '请选择供应商',
      decreaseOverflowReasonPlaceholder: '请选择损溢原因',
      decreaseOverflowPartPlaceholder: '请选择损溢环节',
      decreaseOverflowMarkPlaceholder: '请输入备注',
      voucherNoPlaceholder: ' ',
    },
    form: {
      title: '报损报溢单',
      baseTitle: '基本信息',
      productTitle: '损溢商品信息',
    },
    goodList: {
      batchNo: '业务入库批次号',
      batchNoPlaceholder: '请选择业务批次号',
      productNo: '商品编码',
      productNoPlaceholder: '请选择商品编码',
      productName: '商品描述',
      partner: '供应商',
      decreaseOverflowQuantity: '损溢数量',
      decreaseOverflowQuantityPlaceholder: '请输入损溢数量',
      decreaseOverflowPackage: '损溢件数',
      decreaseOverflowPackagePlaceholder: '请输入损溢件数',
      decreaseOverflowUnit: '单位',
      decreaseOverflowUnitPrice: '本币不含税单价',
      businessDecreaseOverflowAmount: '损溢金额',
      decreaseOverflowPercent: '损溢比例',
      purchaseNo: '采购合同/意向单号',
      puchaseDetailNo: '采购合同/意向单行号',
      puchaseDetailQuantity: '采购合同/意向单数量',
    },
    msg: {
      selectWarehouse: '请选择仓库',
    },
  },
  logisticsLOR: {
    goodList: {
      batchNo: '物流库存批次号',
      batchNoPlaceholder: '请输入物流库存批次号',
    },
  },
};
